// Enum for form modes
export enum FormMode {
  Add = "ADD", // Represents the mode for adding a new item
  Edit = "EDIT", // Represents the mode for editing an existing item
}

// Enum for logo sizes
export enum LogoSize {
  Medium = "logo-medium", // Represents a medium-sized logo
  Small = "logo-small", // Represents a small-sized logo
}
